export default {
  subtotal: {
    id: 'checkout_summary_subtotal',
    defaultMessage: 'Subtotal',
  },
  estimatedTax: {
    id: 'checkout_summary_estimated_tax',
    defaultMessage: 'Estimated tax',
  },
  tax: {
    id: 'checkout_summary_tax',
    defaultMessage: 'Tax',
  },
  pending: {
    id: 'checkout_summary_pending',
    defaultMessage: 'Pending',
  },
  flashSalesTag: {
    id: 'flash_sales_modal_cart_tag',
    defaultMessage: 'Flash Deal promo',
  },
}
